// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"SecondarySearchInput_searchInput__1co8_","filterButton":"SecondarySearchInput_filterButton__1xL1P"};